import { useEffect } from 'react';

import { Rocket, Table, User } from '@mint-lib/icons';
import { Button, Card, typographyVariants } from '@mint-lib/tw-components';
import { Recommendations } from '@mint-sdk/api-emails';
import { getRouteApi } from '@mint/emails-routing';

const routeApi = getRouteApi('/recommendation/confirm');

function ConfirmRouteComponent() {
  const { recommendationData, token } = routeApi.useLoaderData();
  const navigate = routeApi.useNavigate();
  const { mutate: proveAction } = Recommendations.proveAction();
  const { mutate: applyRecommendation } = Recommendations.applyRecommendation();

  useEffect(() => {
    proveAction({
      params: { token },
      data: { action: 'open' },
    });
  }, [proveAction, token]);

  useEffect(() => {
    const status = recommendationData?.status;
    const taxonomy = recommendationData?.taxonomy;

    const platformStatus = taxonomy.channel.platform.status?.data.every(
      (item) => item.status === 'pending',
    );

    if (status === 'EXPIRED') {
      navigate({ to: '/recommendation/expired', replace: true });
      return;
    }
    if (status === 'ACCEPTED' && platformStatus) {
      navigate({ to: '/recommendation/applied', replace: true });
      return;
    }
  }, [recommendationData, navigate]);

  const handleConfirm = () => {
    applyRecommendation({ params: { token } });
    navigate({ to: '/recommendation/thanks', replace: true });
  };

  return (
    <Card
      hover={'noHover'}
      className="flex h-[50vh] w-212.5 items-center justify-center overflow-hidden px-13"
      contentClassName="p-0"
    >
      <div className="flex flex-col items-center justify-center gap-6">
        <h3 className={typographyVariants({ variant: 'h3', color: 'primary' })}>
          Confirm the budget was updated
        </h3>
        <div className="grid w-full grid-cols-3 justify-center gap-8 px-8">
          <div className="flex flex-col items-center justify-start gap-6 py-6">
            <User className="size-14 fill-icon-primary" />
            <h5
              className={typographyVariants({
                variant: 'h5',
                color: 'primary',
                className: 'text-center uppercase',
              })}
            >
              {recommendationData.clientName}
            </h5>
          </div>
          <div className="flex flex-col items-center justify-start gap-6 py-6">
            <Table className="size-14 fill-icon-primary" />
            <h5
              className={typographyVariants({
                variant: 'h5',
                color: 'primary',
                className: 'text-center uppercase',
              })}
            >
              {recommendationData.platformName}
            </h5>
          </div>
          <div className="flex flex-col items-center justify-start gap-6 py-6">
            <Rocket className="size-14 fill-icon-primary" />
            <h5
              className={typographyVariants({
                variant: 'h5',
                color: 'primary',
                className: 'text-center uppercase',
              })}
            >
              {recommendationData.journeyName}
            </h5>
          </div>
        </div>

        <p
          className={typographyVariants({
            variant: 'bodyLong02',
            color: 'secondary',
            className: 'text-center',
          })}
        >
          Click the button below to confirm the budget has been updated on the
          external platform
        </p>

        <Button className="px-14" onClick={handleConfirm}>
          Confirm
        </Button>
      </div>
    </Card>
  );
}

export default ConfirmRouteComponent;
